// import { Virtuoso } from "react-virtuoso";
import { GroupedTableViewportProps } from "./GroupedTableViewport.types";

function GroupedTableViewport({
    children
}: GroupedTableViewportProps) {
    return (
        <div className="GroupedTableViewport">
                {children}
        </div>
    );
}

export default GroupedTableViewport;
